/** v2.2 P2: the note rules the UI needs, kept out of the component so they can be tested alone. */
export interface NoteLike {
  id: string;
  body: string;
  author_email?: string | null;
  author_user_id?: string | null;
  created_at: string;
  updated_at?: string | null;
  /** v2.11 (D-145): an `ai_analysis` note is never a source of phones. */
  kind?: string | null;
}

/** The "· edited" rule: the row moved more than two seconds after it was written. */
export function wasEdited(note: Pick<NoteLike, "created_at" | "updated_at">): boolean {
  if (!note.updated_at) return false;
  return new Date(note.updated_at).getTime() - new Date(note.created_at).getTime() > 2000;
}

/** Owner edits anything; a VA only what they wrote (the API enforces the same rule, D-62). */
export function canEditNote(
  note: Pick<NoteLike, "author_user_id">,
  me: { id: string; role: string } | undefined,
): boolean {
  if (!me) return false;
  if (me.role === "owner") return true;
  return Boolean(note.author_user_id) && note.author_user_id === me.id;
}

